import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-redirect-component',
  template: '',
})
export class RedirectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.location.href = environment.wwwUrl;
  }

}
